/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { collectionGroup, query, where } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { resultOfId } from '@/model/firebase/queryUtils'
import { sortBy } from 'lodash-es'
import store from '@/model/global/store'
import Level from '@/model/dataLayer/api/Vip/Level'

const entity = {
  name: {},
  memberIdentity: {
    displayName: 'MemberInfo',
    formConfig: {
      disableEdit: true
    }
  },
  memberLevel: {
    displayName: 'MemberRank',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Level.getList(true),
        itemText: 'name',
        itemValue: 'uuid'
      }
    }
  },
  checkDetail: {
    displayName: 'detail',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  recharge: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get('https://getmemberlist-evhwqutgjq-ey.a.run.app', {
      deviceId: await getCurrentDeviceId()
    })).data
  },
  add: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    const res = await hillo.jsonPost('https://createmember-evhwqutgjq-ey.a.run.app', {
      ...item
    })
    if (res?.code !== 200) {
      store.commit('showErrorDialog', 'DuplicatedMemberInfoNotAllowed')
    }
  },
  edit: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    return await hillo.jsonPost('https://updatemember-evhwqutgjq-ey.a.run.app', {
      ...item
    })
  },
  remove: async function (item) {

  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getMemberDetailInfo (item) {
  item.deviceId = await getCurrentDeviceId()
  return (await hillo.get('https://getmemberdetail-evhwqutgjq-ey.a.run.app', {
    ...item
  })).data
}

export async function updateMemberDetailPoint (item) {
  await hillo.jsonPost('https://usepoint-evhwqutgjq-ey.a.run.app', {
    ...item
  })
}

export async function getAllPointLog (customerId) {
  const res =
    query(collectionGroup(FireBaseStore,
      'usePointLog'),
    where('pointSourceId', '==', await getCurrentDeviceId()), where('customerId', '==', customerId),
    where('pointType', '==', 'Merchant'))
  return sortBy((await resultOfId(res)), (o) => {
    return -o.electronic_meta_createdAt.seconds
  })
}
